module.exports = __webpack_public_path__ + "img/2-1_10.1b3489c0.jpg";